import { useEffect, useRef } from "react";
import { ModalsRoot } from "side-ui";

import { useRouter } from "@tanstack/react-router";
import { useFlag } from "@unleash/proxy-client-react";

import Navigation from "../components/Navigation";
import { customerIoPage } from "../lib/customerio";

import "./OrganisationLayout.scss";

declare global {
    interface Window {
        analytics?: {
            page: () => void;
        };
    }
}

const OrganisationLayout = ({ children }) => {
    const { history } = useRouter();
    const subscribed = useRef(false);
    const isAttendancesPayrollClosingEnabled = useFlag("attendances-payroll-closing");

    useEffect(() => {
        if (subscribed.current) return;
        function onNavigate() {
            customerIoPage();
            if (window.analytics) {
                window.analytics.page();
            }
        }
        history.subscribe(() => {
            onNavigate();
        });
        // also run on intial load
        onNavigate();
        subscribed.current = true;
    }, []);

    return (
        <div className='flex h-dvh flex-col'>
            {/* Filled by customer.io inline messages */}
            {isAttendancesPayrollClosingEnabled ? (
                <div id='cio-mkg' ref={trackBannerHeight} className='empty:hidden'></div>
            ) : null}
            <div className='organisation__layout min-h-0 flex-1'>
                <Navigation />
                <div className='min-w-0 flex-1 overflow-auto'>{children}</div>
            </div>
            <ModalsRoot />
        </div>
    );
};

// Exposes the banner real height as --cio-banner-height (see core.scss) so that full-height
// screens and fixed elements can make room for it
function trackBannerHeight(banner: HTMLDivElement | null) {
    if (!banner) return;
    const root = document.documentElement;
    const observer = new ResizeObserver(([entry]) => {
        const height = entry.borderBoxSize[0]?.blockSize ?? banner.offsetHeight;
        root.style.setProperty("--cio-banner-height", `${height}px`);
    });
    observer.observe(banner);
    return () => {
        observer.disconnect();
        root.style.removeProperty("--cio-banner-height");
    };
}

export default OrganisationLayout;
